/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
import './subcription.css'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';

function Subcription() {
    const navigate = useNavigate();

    return (
        <>
            <>
                <main>
                    <section className="section-4">
                        <h5 className='text-start w-100 mb-1'><i className="me-4" onClick={() => navigate(-1)}><KeyboardBackspaceIcon color='primary' fontSize='small' /></i>Transactions</h5>
                        <div className='w-100 ps-5'>
                            <h5 className='text-start'>Summary <small>(updated every 24 hours)</small></h5>
                        </div>
                        <div className="section-4-2">
                            <div className="section-main">
                                <div className="pricing-body">
                                    <div className="pricing-body-plans">
                                        <div className="active" id="pricing__monthly__plan">
                                            <div>
                                                <div className="card">
                                                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                                                        <p>This month so far</p>
                                                        <p>(1st Feb 2024 - Present)</p>
                                                        <h2 className="card-price">$4.41</h2>
                                                    </div>
                                                    <div className="card-body">
                                                        <ul>
                                                            <li>
                                                                <p>Call (1)</p>
                                                                <p className="price-color">$0.0198</p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                                                        <p>This month so far</p>
                                                        <p>(1st Feb 2024 - Present)</p>
                                                        <h2 className="card-price">$4.41</h2>
                                                    </div>
                                                    <div className="card-body">
                                                        <ul>
                                                            <li>
                                                                <p>Call (1)</p>
                                                                <p className="price-color">$0.0198</p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </>

        </>
    )
}
export default Subcription

